import {memo} from 'react';

import type {SVGProps} from 'react';

export const SwapIcon = memo(function SwapIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={20}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 15H17M13 19L17 15L13 11M17 5H1M5 9L1 5L5 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
